import React from 'react'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import CheckIcon from '@mui/icons-material/Check'

function FooterEmailFormSubmittedAlert ({ show, type, message, onClose }) {
  return (
    <Snackbar
      open={show}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
      onClose={(event, reason) => reason !== 'clickaway' && onClose() }
    >
      <Alert
        icon={<CheckIcon fontSize="inherit" />}
        severity={type}
        variant="filled"
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default FooterEmailFormSubmittedAlert
